import { ETextStyleVariant, LinkButton, Text } from '@outdoorsyco/bonfire';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import useSWR from 'swr';

import { ShareModal } from '@/components/route/referral/ShareModal';
import { EToastVariant, useToast } from '@/hooks/useToast';
import { getUser } from '@/redux/selectors/auth/user';
import { trackReferralCodeSharedEvent } from '@/services/analytics/referral';
import apiRequest from '@/services/apiRequest';
import { EShareMethodType, IReferralStatsProps } from '@/services/types/referral/referral';
import { getCoreApi } from '@/utility/getCoreApi';

export const Share = () => {
  const intl = useIntl();
  const { showToast } = useToast();

  const user = useSelector(getUser);

  const { data: referralStats } = useSWR(`${getCoreApi()}/referrals/stats`, url =>
    apiRequest<IReferralStatsProps>({ url }, true),
  );

  const [shareModalIsOpened, setShareModalIsOpened] = useState(false);

  if (!user) return null;

  const shareUrl = `${process.env.hostApp}/invite/${user.referral_code}`;

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([shareUrl], {
            type: 'text/plain',
          }),
        }),
      ]);

      trackReferralCodeSharedEvent({
        shareMethod: EShareMethodType.COPY_LINK,
        referralType: 'renter',
        currentEarningsEarned: (referralStats?.earned_credits || 0) / 100,
        currentEarningsPending: (referralStats?.pending_credits || 0) / 100,
      });

      showToast(
        EToastVariant.Success,
        intl.formatMessage({ defaultMessage: 'Link copied!', id: '/vCdX1' }),
        intl.formatMessage({ defaultMessage: 'Successfully copied the link.', id: 'exB6r0' }),
      );
    } catch {
      showToast(
        EToastVariant.Error,
        intl.formatMessage({ defaultMessage: 'Oops!', id: 'BEbOqj' }),
        intl.formatMessage({
          defaultMessage: 'Something went wrong, please try again.',
          id: '8GvVWZ',
        }),
      );
    }
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <Text variant={ETextStyleVariant.MediumBold} className="truncate">
        {shareUrl}
      </Text>

      <div className="flex gap-4">
        <LinkButton
          label={intl.formatMessage({ defaultMessage: 'Copy', id: '4l6vz1' })}
          onClick={handleCopyToClipboard}
        />

        <LinkButton
          label={intl.formatMessage({ defaultMessage: 'Share', id: 'OKhRC6' })}
          onClick={() => setShareModalIsOpened(true)}
        />

        <ShareModal
          shareUrl={shareUrl}
          isOpened={shareModalIsOpened}
          onClose={() => setShareModalIsOpened(false)}
        />
      </div>
    </div>
  );
};
